export function generateBackgroundColorClass(backgroundColor) {
    /**
     * Tailwind Background Color Whitelist
     *
     * Because we are dynamically creating the class names to reduce the JS complexity
     * we have to list these classes out so they don't get purged during the build process
     *
     * bg-white
     * bg-black
     * bg-primary
     * bg-primary-light
     * bg-secondary-dark
     * bg-gray-light
     * bg-gray-lighter
     * bg-gray-lightest
     * bg-gray-darkest
     * bg-success
     * bg-success-light
     * bg-info
     * bg-info-dark
     * bg-warning-light
     */
    if (!backgroundColor || backgroundColor === 'NONE') return ''
    return `bg-${backgroundColor.replace('_', '-').toLowerCase()}`
}

// NOTE: This function currently returns the class that adds the border too.
// In the future if and when we support thickness we would have to change that.
export function generateBorderClass(borderColor) {
    /**
     * Tailwind Border Color Whitelist
     *
     * Because we are dynamically creating the class names to reduce the JS complexity
     * we have to list these classes out so they don't get purged during the build process
     *
     * border-black
     * border-gray
     * border-gray-light
     */
    if (!borderColor || borderColor === 'NONE') return ''
    return `border border-${borderColor.replace('_', '-').toLowerCase()}`
}

export function generateFontColorClass(fontColor) {
    /**
     * Tailwind Text Color Whitelist
     *
     * Because we are dynamically creating the class names to reduce the JS complexity
     * we have to list these classes out so they don't get purged during the build process
     *
     * text-black
     * text-white
     * text-primary
     * text-action
     * text-success
     * text-gray
     */
    if (!fontColor || fontColor === 'INHERIT') return ''
    return `text-${fontColor.replace('_', '-').toLowerCase()}`
}
